import { ProcedureTypeEnum } from './procedure-type.enum';
import { ProcedureEnum } from './procedure.enum';
import { ProcedureMapEnum } from './procedure-map.enum';

export interface ProcedureMapCheckedValue {
	ProcedureId?: ProcedureEnum | number;
	TypeId?: ProcedureTypeEnum | number;
	Id?: ProcedureMapEnum | number; // Procedure map id. To be compatible with type ProcedureMap
}

export interface ProcedureMapCompositePattern {
	ProcedureId: ProcedureEnum | number;
	TypeId?: ProcedureTypeEnum | number;
}

export const procedureMapComposites = {
	fixedRestorativeAll: {
		ProcedureId: ProcedureEnum.FixedRestorative,
		TypeId: ProcedureTypeEnum.None
	}
} as const satisfies Record<string, ProcedureMapCompositePattern>;
